var React = require('react');

function SeparatorArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 -2.62268e-07L0.999999 21L7 26.5L0.999999 32L0.999998 52","stroke":"#DDE1E3"}));
}

SeparatorArrow.defaultProps = {"width":"8","height":"52","viewBox":"0 0 8 52","fill":"none"};

module.exports = SeparatorArrow;

SeparatorArrow.default = SeparatorArrow;
